import React from 'react'
import moment from 'moment'
import { ContractNotificationEventType, IContractNotification } from '@api/types'
import { IPortfolio } from './hooks/usePortfolio'
import { startCase } from 'lodash'
import { Button, Popover } from '@runeffective/evo-design-system'
import { Icon, IconButton, Link } from '@ui'
import { Nav } from '@utils'
import css from './portfolioDetails.module.scss'
import { DateUtil } from '@utils/dateUtil'
import api from '@api'

interface IProps {
  buildingId: string
  notifications?: IContractNotification[]
  hook?: IPortfolio
  iconcolor?: string
  customDismiss?: (nId: string, buildingId: string) => void
}

export default function Notifications({
  notifications,
  buildingId,
  hook,
  iconcolor,
  customDismiss,
}: IProps) {
  if (!notifications || !notifications.length) return null

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Popover
        hasArrow
        placement="bottom"
        style={{
          minWidth: 400,
          zIndex: 14,
        }}
        triggerElement={
          <Button aria-label="button" size="small" layout="borderless">
            <Icon
              name="exclamation-triangle"
              style={{ color: `${iconcolor || 'var(--primary-color)'}` }}
            />
          </Button>
        }
      >
        <Popover.Header>
          <div
            className="p2"
            style={{
              borderBottom: '1px solid var(--border-color)',
              background: 'var(--light-grey)',
            }}
          >
            Lease Alerts
          </div>
        </Popover.Header>
        <Popover.Content>
          {notifications.map((n, i) => {
            const date = eventTypeToField(n.eventType, n.data)
            return (
              <div className={css.notification}>
                <div key={i} style={{ borderBottom: '1px solid var(--border-color)' }}>
                  <div className="f pt2 ph2">
                    <div className="pr3 f10">
                      <Link
                        onClick={() => {
                          Nav.lease({ leaseId: n.data.id })
                        }}
                      >
                        This {startCase(n.eventType.toLowerCase())}
                      </Link>{' '}
                      {'is coming up '}
                      {fromNow(date)} on {DateUtil(date).format('MMMM D, YYYY')}
                    </div>
                    <div className="ph3 f00" style={{ flexBasis: 50 }}>
                      <IconButton
                        iconName="trash"
                        minimal
                        style={{ backgroundColor: 'var(--white' }}
                        onClick={() => {
                          api.lease.updateNotification(n.id, 'DISMISSED')
                          hook?.dismissNotification(n.id, buildingId) ??
                            customDismiss?.(n.id, buildingId)
                        }}
                        tooltip="Dismiss alert from my list"
                      />
                    </div>
                  </div>
                  <div className="ph2 pb2" style={{ color: 'var(--grey1)' }}>
                    Created {ago(n.createdAt)}
                  </div>
                </div>
              </div>
            )
          })}
        </Popover.Content>
      </Popover>
    </div>
  )
}

function eventTypeToField(type: ContractNotificationEventType, data: any) {
  switch (type) {
    case 'LEASE_NOTICE_DATE':
      return data.noticeDate
    case 'LEASE_REMINDER_DATE':
      return data.reminderDate
    case 'LEASE_EFFECTIVE_DATE':
      return data.effectiveDate
    case 'LEASE_END_DATE':
      return data.endDate
  }
}

function fromNow(date: string) {
  const diff = moment(date).diff(moment(), 'M')
  if (diff) return `in ${diff} month${diff === 1 ? '' : 's'}`
  return 'this month'
}

function ago(date: string) {
  const diff = moment().diff(date, 'd')
  if (diff) return `${diff} day${diff === 1 ? '' : 's'} ago`
  return 'today'
}
